import algosdk from "algosdk";
import { network } from "@/config";
import { useNodeStore } from "@/store/node";

const nodeConfig = useNodeStore.getState();

export const algodNetwork = network;
export const algodHost = nodeConfig.algodHost;
export const algodPort = nodeConfig.algodPort;
export const algodToken = nodeConfig.algodToken;

export const algod = new algosdk.Algodv2(nodeConfig.algodToken, nodeConfig.algodHost, nodeConfig.algodPort);
export const indexer = new algosdk.Indexer(nodeConfig.indexerToken, nodeConfig.indexerHost, nodeConfig.indexerPort);

export const defaultValidityWindow = 66;